export const GET_NOTIFICATIONS = "GET_NOTIFICATIONS";
export const GET_NOTIFICATIONS_OPTIONS = "GET_NOTIFICATIONS_OPTIONS";
export const RESET_NOTIFICATIONS = "RESET_NOTIFICATIONS";
export const SET_NOTIFICATIONS_REQUEST_STATUS = "SET_NOTIFICATIONS_REQUEST_STATUS";
